export default (contentId, pKey) => (
  `//valentino-cdn.thron.com/delivery/public/thumbnail/valentino/${contentId}/${pKey}/std/0x0/${contentId}`
);
